module.exports = __webpack_public_path__ + "static/media/assembly_A1.9483f265.png";